import * as React from 'react';
import {WidgetProps} from 'react-jsonschema-form';
import DateTimePicker from 'material-ui-pickers/DateTimePicker';

/**
 * This is the default version, as the main version, we list all the items,
 * we don't care about material-ui
 */

export default (props: WidgetProps) => {
    const options = props.options as any;
    const onChange = (data: Date) => {

        console.log(data);
        if (!data) {
            props.onChange(options.emptyValue || null);
        }

        return props.onChange(data.toISOString());
    };

    const val = isNaN(Date.parse(props.value)) ? null : new Date(props.value);

    return (
        <DateTimePicker
            format="[ El ]DD/MM/YYYY [a las] hh:mm"
            style={{
                width: '95%',
                marginLeft: '2px'
            }}
            mask={(value: any) => (value ? [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/] : [])}
            value={val}

            disabled={props.disabled || props.readonly}
            autoFocus={props.autofocus}
            onChange={onChange}/>);
};



// WEBPACK FOOTER //
// ./src/components/schemaform/date-time-widget.tsx